import { AxiosGet, AxiosGetToken } from "./AxiosCall";

export const DashboardApi = async ({ start_date, end_date }) => {
  try {
    let res = await AxiosGetToken("dashboard", {
      start_date: start_date ?? null,
      end_date: end_date ?? null,
    });
    return res;
  } catch (error) {
    return error;
  }
};


export const DashboardNoTokenApi = async ({ start_date, end_date }) => {
  try {
    let res = await AxiosGet("dashboard", {
      start_date: start_date ?? null,
      end_date: end_date ?? null,
    });
    return res;
  } catch (error) {
    return error;
  }
};
